import Homesec1 from "../../components/Home/Homesec1";

const Home = () => {
    return(
        <Homesec1/>
    );
}

export default Home;